module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Grupo de Permissão")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "pull-right hidden-print",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'config.grupos.list'
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nome),
      expression: "data.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Selecionar permissões")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Permissões disponíveis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroDisponiveis),
      expression: "filtroDisponiveis"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrar permissões"
    },
    domProps: {
      "value": (_vm.filtroDisponiveis)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroDisponiveis = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.permissions),
      expression: "data.permissions"
    }],
    staticClass: "form-control select-multiple",
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "permissions", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.filteredAvailablePermissions), function(p) {
    return _c('option', {
      key: p.id,
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p.nome))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn btn-sm m-b-xs m-r-xs btn-default",
    on: {
      "click": _vm.addAllPermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar todos\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Permissões selecionadas")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroSelecionados),
      expression: "filtroSelecionados"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrar permissões"
    },
    domProps: {
      "value": (_vm.filtroSelecionados)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroSelecionados = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control select-multiple"
  }, [_c('ul', {
    staticClass: "list-group",
    staticStyle: {
      "list-style-type": "none"
    }
  }, _vm._l((_vm.filteredSelectedPermissions), function(p, index) {
    return _c('li', {
      key: p.id,
      attrs: {
        "value": p.id
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Clique para remover este item"
      },
      on: {
        "click": function($event) {
          return _vm.removePermission(index)
        }
      }
    }), _vm._v(" " + _vm._s(p.nome) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn btn-sm m-b-xs m-r-xs btn-default",
    on: {
      "click": _vm.removeAllPermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Remover todos\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    on: {
      "click": _vm.submit
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'config.grupos.list'
        })
      }
    }
  }, [_vm._v("Cancelar")])], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5072b0da","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/configuracoes/grupos-permissao/components/NovoGrupo.vue
// module id = 1666
// module chunks = 17